export function handleResponse(response) {
  // if (response.results) {
  //   return response.results;
  // }
  // if (response.data) {
  //   return response.data;
  // }

  //handling for save filters
  if (response.data.error.length > 0) {
    return {
      status: response.status,
      error: response.data.error,
      data: response.data.error,
    };
  }

  if (
    response.data.success.length > 0 &&
    typeof response.data.data === "undefined"
  ) {
    return {
      status: response.status,
      success: response.data.success,
      data: response.data.success,
    };
  }

  //everything else
  return { status: response.status, data: response.data.data };
}

export function handleError(error) {
  // if (error.data) {
  //   return error.data;
  // }
  if (error.response) {
    return { status: error.response.status, data: error.response.data };
  } else if (error.request) {
    return { status: 400, data: {} };
  } else {
    return { status: 400, data: {} };
  }
}
